import { I18n } from '@calendly/i18n';
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextWarning } from '@calendly/ui/theme';
import React from 'react';
import type { WarningKey } from 'components/meetings/utils';
const warningContainerCss = "wuoekfx";
const warningTextCss = "w17pllql";
interface WarningConfig {
  i18nKey: string;
}
const WARNING_CONFIGS: Record<WarningKey, WarningConfig> = {
  PAYMENT_ERROR: {
    i18nKey: 'publisher.meetings.header_badge.payment_error'
  },
  ACTION_NEEDED: {
    i18nKey: 'publisher.meetings.header_badge.action_needed'
  },
  EXPIRED: {
    i18nKey: 'publisher.meetings.header_badge.expired'
  },
  INVITEES_DECLINED: {
    i18nKey: 'publisher.meetings.header_badge.invitees_declined'
  },
  CONFLICT: {
    i18nKey: 'publisher.meetings.header_badge.conflict'
  }
};
export interface MeetingWarningIndicatorProps {
  warningKey: WarningKey;
}

/**
 * Renders a warning indicator for actionable meeting statuses such as
 * payment errors, conflicts, expired events, and declined invitees.
 * All warnings display with an alert triangle icon and warning-colored text.
 * Used alongside MeetingStatusIndicator.
 */
export const MeetingWarningIndicator: React.FC<MeetingWarningIndicatorProps> = ({
  warningKey
}) => {
  const config = WARNING_CONFIGS[warningKey];
  if (!config) {
    return null;
  }
  return <div className={warningContainerCss}>
      <AlertWarningTriangleIcon color={colorTextWarning} />
      <BodyText size="small" weight="semibold" color={colorTextWarning} inline>
        <div className={warningTextCss}>
          {I18n.t(config.i18nKey)}
        </div>
      </BodyText>
    </div>;
};

require("./MeetingWarningIndicator.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingWarningIndicator.tsx");